import React from 'react';
import {
    DiscoverButtonContainer,
    InformationSectionContainer, InformationSectionDescription,
    InformationSectionDevicesSvgContainer,
    InformationSectionTextContainer, InformationSectionTitle, ViewAllGamesContainer, ViewAllGamesText
} from './PageInformationStyle';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import { ReactComponent as IntroductionDevices } from '../../assets/introductionDevices.svg';
import { ReactComponent as CaretComponent } from '../../assets/caretSvg.svg';
import { DiscoverUbisoftPlusButtonContainer } from '../UI/Buttons/DiscoverUbisoftPlusButton/DiscoverUbisoftPlusButtonContainer';
import { getNavigationPageLink } from '../../utils/navigation';

const PageInformationContainer = ({ context }: IContext) => {
    return (
        <InformationSectionContainer>
            <InformationSectionTextContainer>
                <InformationSectionDevicesSvgContainer>
                    <IntroductionDevices/>
                </InformationSectionDevicesSvgContainer>
                <InformationSectionTitle dangerouslySetInnerHTML={{ __html: context.title }} />
                <InformationSectionDescription
                    dangerouslySetInnerHTML={{ __html: context.description }} />
                <DiscoverButtonContainer>
                    <DiscoverUbisoftPlusButtonContainer content={context.discoverUbisoftPlus} redirect={getNavigationPageLink('landing')}/>
                </DiscoverButtonContainer>

                <ViewAllGamesContainer>
                    <ViewAllGamesText href={getNavigationPageLink('games')}>{context.viewAllGames}</ViewAllGamesText>
                    <CaretComponent/>
                </ViewAllGamesContainer>
            </InformationSectionTextContainer>
        </InformationSectionContainer>
    );
};

export default withContent(PageInformationContainer);